// 첫화면 인사말 — 세계 각국 인사를 시간대(아침·점심·저녁)에 맞춰 현지 문자로
// 랜덤하게 보여준다. 새 채팅·새로고침마다 바뀐다 (ChatPage 가 마운트·빈 화면
// 복귀 시마다 pickGreeting 을 다시 부른다). 마우스를 올리면
// "이탈리아어 · 점심 인사 · 부온 포메리조" 형식의 툴팁이 뜬다.

export interface Greeting {
  text: string;
  lang: string;   // 툴팁용 언어명
  roman?: string; // 한글 발음 — 한국어 인사는 생략
}

export const GREETINGS: Record<"morning" | "afternoon" | "evening", Greeting[]> = {
  morning: [
    { text: "좋은 아침이에요", lang: "한국어" },
    { text: "Good morning", lang: "영어", roman: "굿 모닝" },
    { text: "おはようございます", lang: "일본어", roman: "오하요 고자이마스" },
    { text: "早上好", lang: "중국어", roman: "자오샹 하오" },
    { text: "Guten Morgen", lang: "독일어", roman: "구텐 모르겐" },
    { text: "Bonjour", lang: "프랑스어", roman: "봉주르" },
    { text: "Buongiorno", lang: "이탈리아어", roman: "부온조르노" },
    { text: "Buenos días", lang: "스페인어", roman: "부에노스 디아스" },
    { text: "Bom dia", lang: "포르투갈어", roman: "봉 지아" },
    { text: "Доброе утро", lang: "러시아어", roman: "도브로예 우트라" },
    { text: "Selamat pagi", lang: "인도네시아어", roman: "슬라맛 파기" },
    { text: "สวัสดีตอนเช้า", lang: "태국어", roman: "사왓디 똔 차오" },
    { text: "Chào buổi sáng", lang: "베트남어", roman: "짜오 부오이 상" },
    { text: "صباح الخير", lang: "아랍어", roman: "사바흐 알카이르" },
    { text: "शुभ प्रभात", lang: "힌디어", roman: "슈브 프라밧" },
    { text: "Günaydın", lang: "튀르키예어", roman: "귀나이든" },
    { text: "Goedemorgen", lang: "네덜란드어", roman: "후더모르헌" },
    { text: "God morgon", lang: "스웨덴어", roman: "구드 모르곤" },
    { text: "Καλημέρα", lang: "그리스어", roman: "칼리메라" },
    { text: "Dzień dobry", lang: "폴란드어", roman: "진 도브리" },
    { text: "Bonum mane", lang: "라틴어", roman: "보눔 마네" },
  ],
  afternoon: [
    { text: "좋은 오후예요", lang: "한국어" },
    { text: "Good afternoon", lang: "영어", roman: "굿 애프터눈" },
    { text: "こんにちは", lang: "일본어", roman: "곤니치와" },
    { text: "下午好", lang: "중국어", roman: "샤우 하오" },
    { text: "Guten Tag", lang: "독일어", roman: "구텐 탁" },
    { text: "Bon après-midi", lang: "프랑스어", roman: "봉 아프레미디" },
    { text: "Buon pomeriggio", lang: "이탈리아어", roman: "부온 포메리조" },
    { text: "Buenas tardes", lang: "스페인어", roman: "부에나스 타르데스" },
    { text: "Boa tarde", lang: "포르투갈어", roman: "보아 타르지" },
    { text: "Добрый день", lang: "러시아어", roman: "도브리 젠" },
    { text: "Selamat siang", lang: "인도네시아어", roman: "슬라맛 시앙" },
    { text: "สวัสดีตอนบ่าย", lang: "태국어", roman: "사왓디 똔 바이" },
    { text: "Chào buổi chiều", lang: "베트남어", roman: "짜오 부오이 찌에우" },
    { text: "نهارك سعيد", lang: "아랍어", roman: "나하룩 사이드" },
    { text: "नमस्ते", lang: "힌디어", roman: "나마스떼" },
    { text: "İyi günler", lang: "튀르키예어", roman: "이이 귄레르" },
    { text: "Goedemiddag", lang: "네덜란드어", roman: "후더미다흐" },
    { text: "God eftermiddag", lang: "스웨덴어", roman: "구드 에프테르미다그" },
    { text: "Καλό απόγευμα", lang: "그리스어", roman: "칼로 아포예브마" },
    { text: "Dzień dobry", lang: "폴란드어", roman: "진 도브리" },
    { text: "Salve", lang: "라틴어", roman: "살웨" },
  ],
  evening: [
    { text: "좋은 저녁이에요", lang: "한국어" },
    { text: "Good evening", lang: "영어", roman: "굿 이브닝" },
    { text: "こんばんは", lang: "일본어", roman: "곰방와" },
    { text: "晚上好", lang: "중국어", roman: "완샹 하오" },
    { text: "Guten Abend", lang: "독일어", roman: "구텐 아벤트" },
    { text: "Bonsoir", lang: "프랑스어", roman: "봉수아르" },
    { text: "Buonasera", lang: "이탈리아어", roman: "부오나세라" },
    { text: "Buenas noches", lang: "스페인어", roman: "부에나스 노체스" },
    { text: "Boa noite", lang: "포르투갈어", roman: "보아 노이치" },
    { text: "Добрый вечер", lang: "러시아어", roman: "도브리 베체르" },
    { text: "Selamat malam", lang: "인도네시아어", roman: "슬라맛 말람" },
    { text: "สวัสดีตอนเย็น", lang: "태국어", roman: "사왓디 똔 옌" },
    { text: "Chào buổi tối", lang: "베트남어", roman: "짜오 부오이 또이" },
    { text: "مساء الخير", lang: "아랍어", roman: "마사 알카이르" },
    { text: "शुभ संध्या", lang: "힌디어", roman: "슈브 산디야" },
    { text: "İyi akşamlar", lang: "튀르키예어", roman: "이이 악샴라르" },
    { text: "Goedenavond", lang: "네덜란드어", roman: "후더나본트" },
    { text: "God kväll", lang: "스웨덴어", roman: "구드 크벨" },
    { text: "Καλησπέρα", lang: "그리스어", roman: "칼리스페라" },
    { text: "Dobry wieczór", lang: "폴란드어", roman: "도브리 비에추르" },
    { text: "Bonum vesperum", lang: "라틴어", roman: "보눔 웨스페룸" },
  ],
};

export const BUCKET_LABELS = { morning: "아침", afternoon: "점심", evening: "저녁" } as const;

/** 아침 05–11시, 점심 12–17시, 저녁 18–04시 */
export function timeBucket(hour: number): keyof typeof GREETINGS {
  if (hour >= 5 && hour < 12) return "morning";
  if (hour >= 12 && hour < 18) return "afternoon";
  return "evening";
}

export function pickGreeting(
  rand: () => number = Math.random,
  hour: number = new Date().getHours(),
): Greeting & { bucket: keyof typeof GREETINGS } {
  const bucket = timeBucket(hour);
  const list = GREETINGS[bucket];
  return { ...list[Math.floor(rand() * list.length)], bucket };
}

/** 툴팁 문구 — "이탈리아어 · 점심 인사 · 부온 포메리조" */
export function greetingTitle(g: Greeting & { bucket: keyof typeof GREETINGS }): string {
  return `${g.lang} · ${BUCKET_LABELS[g.bucket]} 인사${g.roman ? ` · ${g.roman}` : ""}`;
}
